import { MANUAL_MESSAGES_STATUS, MESSAGE_STATUS } from '../../constants';
import { MANUAL_ACTIONS } from '../actions/A_manual_message';

const initialState = {
    prevManualMessageStatus: MANUAL_MESSAGES_STATUS.SEND,
	manualMessageStatus: MANUAL_MESSAGES_STATUS.SEND,
    phone: undefined,
	convId: 0
};

const manualMessageReducer = (state = initialState, action) => {
	switch (action.type) {
		case MANUAL_ACTIONS.SET_MESSAGE_STATUS:
			return { ...state, prevManualMessageStatus: state.manualMessageStatus, manualMessageStatus: action.manualMessageStatus, phone: action.phone, convId: action.convId };
		case MANUAL_ACTIONS.SET_MESSAGE_CONV_ID:
			return {...state, convId: action.convId};
		case MANUAL_ACTIONS.MULTIMEDIA_MESSAGE_STATUS:
			if(state.convId === action.conversationId){
				let messageStatus = MANUAL_MESSAGES_STATUS.SYSTEM_ERROR;
				let newPhone = state.phone;
				switch(action.status){
					case MESSAGE_STATUS.send:
					case MESSAGE_STATUS.delivered:
						messageStatus = MANUAL_MESSAGES_STATUS.SEND;
						newPhone = undefined;
						break;
					case MESSAGE_STATUS.error:
						messageStatus = MANUAL_MESSAGES_STATUS.INCORRECT_NUMBER;
						break;
				}
				return {...state, prevManualMessageStatus: state.manualMessageStatus, manualMessageStatus: messageStatus, phone: newPhone};
			}
			return state;
		default:
			return state;
	}
};

export default manualMessageReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/reducer_manual_message.js